import React, {useEffect, useState} from "react";
import {
    Grid,
    Mui,
    MuiIcons,
    MuiLab,
    enumNamesToSelect,
    CustomDatePicker,
    SelectForObject,
    AlertTypes,
    MainLoader
} from "@leap4/frontend";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {addOwnershipToDB, getAllTags} from "../../actions/users";
import {InputSlider} from "./InputSlider";
import {IOwnership} from "@leap4/general-common";
import {defaultOwnershipObj} from "./owneship";
import {setAlert} from "../../actions/alert";

const {Dialog, DialogActions, DialogContentText, DialogTitle, DialogContent, TextField, Button} = Mui;
const {DoneAll: DoneAllIcon} = MuiIcons;
const {LoadingButton} = MuiLab;

const mapStateToProps = () => ({});

const mapActions = {
    setAlert
}

const Metrics = {
    PERCENT: "PERCENT",
    NUMBER: "NUMBER",
}

const MetricSelect = enumNamesToSelect(Metrics);

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface IUserViewsDialogProps extends PropsFromRedux {
    organization: {id: string, name: string},
    isViewsPopupOpen: boolean
    setViewsPopupOpen: (isOpen: boolean) => void,
}

const _OwnershipDialog = (props: IUserViewsDialogProps) => {
    const dispatch = useDispatch();
    const {isViewsPopupOpen, setViewsPopupOpen, organization ,setAlert} = props;
    const [metric, setMetrics ] = useState<string>(Metrics.NUMBER);
    const [isLoading, setIsLoading] = useState<boolean>();
    const [adServerTags, setAdServerTags] = useState<{name: string, id: string, publisherTags: []}[]>([]);
    const [publisherTags, setPublisherTags] = useState<{name: string, id: string}[]>([]);
    const [ownership, setOwnership] = useState<IOwnership>(defaultOwnershipObj)

    const addOwnership = async() => {
        if(ownership.publisherTag === null || ownership.supplyTag === null) {
            setAlert("Tags are not picked!", AlertTypes.FAILURE)
            return;
        }
        if(ownership.percent === 0 && ownership.ownershipValue === 0) {
            setAlert("Set the value!", AlertTypes.FAILURE)
            return;
        }
        try {
            setIsLoading(true)
            await addOwnershipToDB(dispatch, ownership);
        } catch (err) {
            setAlert(err.toString(), AlertTypes.FAILURE)
        } finally {
            setIsLoading(false)
        }
        setViewsPopupOpen(false)
        window.location.reload();
    }

    const setValueForOwnership = (val: any) => {
        setOwnership(prevState => ({
            ...prevState,
            ownershipValue: Number(val.target.value),
            percent: 0
        }))
    }

    function closeDialog() {
        setViewsPopupOpen(false)
    }

    function setPublisherTag(tag) {
        if (tag) {
            setOwnership(prevState => ({
                ...prevState,
                publisherTag: tag.target.value
            }))
        }
    }

    function setSupplyTag(tag) {
        setOwnership(prevState => ({
            ...prevState,
            supplyTag: tag.target.value,
            publisherTag: null
        }))
    }

    async function changeMetric(pick) {
        await setMetrics(pick.target.value);
    }

    function searchTagsForPickedDate(date?: Date) {
        if (date) {
            setOwnership({
                supplyTag: null,
                publisherTag: null,
                timestamp: date,
                percent: 0,
                ownershipValue: 0,
            })
        } else {
            date = ownership.timestamp;
        }
        let loadedTags;
        (async () => {
            try {
                setIsLoading(true);
                loadedTags = await getAllTags(dispatch, date, organization.id);
                setAdServerTags(loadedTags.filter(tag => tag.publisherTags.length));
                setOwnership(prevState => ({
                    ...prevState,
                    supplyTag: null,
                    publisherTag: null
                }))
            } catch (err) {
            } finally {
                setIsLoading(false);
            }
        })()
    }

    useEffect(() => {
        searchTagsForPickedDate(ownership.timestamp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!ownership.supplyTag) {
            return;
        }
        const publisherTag = adServerTags.find(tag => tag.id === ownership.supplyTag.toString()).publisherTags
        setPublisherTags(publisherTag)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ownership.supplyTag]);

    useEffect(() => {
        if (!publisherTags) {
            setPublisherTags([]);
            return;
        }
    }, [publisherTags]);

    return (
        <Dialog open={isViewsPopupOpen} onClose={() => setViewsPopupOpen(false)} maxWidth={'md'} fullWidth>
            <DialogTitle>Add Ownership</DialogTitle>
            <DialogContentText style={{fontSize: 14}}>Here you can add ownership for {organization.name} </DialogContentText>
            <DialogContent>
                {isLoading ? (
                    <Grid item padding={0}>
                        <MainLoader/>
                    </Grid>
                ) : (
                <Grid container gap={1}>
                    <Grid container  alignItems={'center'} gap={2} >
                        <Grid item lg={10} display={'flex'} justifyContent={'flex-start'} flexDirection={'column'}>
                            <TextField type={'text'}
                                       value={organization.name}
                                       onChange={addOwnership}
                                       disabled={true}
                            />
                        </Grid>
                        <Grid item padding={0} >
                            <CustomDatePicker
                                date={ownership.timestamp}
                                setSelectedDate={(date) => searchTagsForPickedDate(date)}
                                textFieldLabel={"Date"}/>
                        </Grid>
                        <Grid item  flex={0} padding={0}  gap={0}>
                        <Button
                            id={'closeButton'}
                            key={'closeButton'}
                            variant={'contained'}
                            onClick={() => searchTagsForPickedDate()}>
                            Refresh
                        </Button>
                        </Grid>
                        <Grid item xs={10} >
                            <SelectForObject
                                valueKey={"id"}
                                labelKey={"name"}
                                value={ownership.supplyTag || ''}
                                label={'Supply Tags'}
                                title={'Supply Tags (' + adServerTags.length + ')'}
                                name={"supplyTags"}
                                items={adServerTags}
                                fullWidth={true}
                                disabled={adServerTags.length === 0}
                                onChange={setSupplyTag}
                            />
                        </Grid>
                        <Grid item xs={10}>
                            <SelectForObject
                                valueKey={"id"}
                                labelKey={"name"}
                                label={'Publisher Tags'}
                                name={"publisherTags"}
                                title={'Publisher Tags (' + publisherTags.length + ')'}
                                value={ownership.publisherTag || ''}
                                items={publisherTags}
                                fullWidth={true}
                                disabled={publisherTags ? publisherTags.length === 0 : false}
                                onChange={setPublisherTag}
                            />
                        </Grid>
                        <Grid container padding={0}  gap={3}>
                            <MetricSelect
                                required
                                value={metric}
                                onChange={changeMetric}
                                disabled={!ownership.publisherTag || !ownership.supplyTag}
                                name="metric"/>
                            {metric === "PERCENT" ? (
                                    <InputSlider
                                        ownership={ownership}
                                        setOwnership={setOwnership}
                                    ></InputSlider>
                            ) : (
                            <TextField type={'number'}
                                       required
                                       value={ownership.ownershipValue || ''}
                                       disabled={!ownership.publisherTag || !ownership.supplyTag}
                                       label={"Value"}
                                       onChange={setValueForOwnership}
                            />
                                )}
                        </Grid>
                    </Grid>
                </Grid>
                            )}
            </DialogContent>
            <DialogActions>
                <LoadingButton
                    id={'closeButton'}
                    key={'closeButton'}
                    variant={'contained'}
                    color={'error'}
                    loading={isLoading}
                    onClick={() => closeDialog()}>
                    Cancel
                </LoadingButton>
                <LoadingButton
                    id={'addButton'}
                    key={'addButton'}
                    variant={'contained'}
                    color={'success'}
                    loading={isLoading}
                    startIcon={<DoneAllIcon/>}
                    loadingPosition="start"
                    onClick={() => addOwnership()}>
                    Add
                </LoadingButton>


            </DialogActions>
        </Dialog>
    )
}

export const AddOwnershipDialog = connect(mapStateToProps, {
    setAlert
})(_OwnershipDialog);
